module.exports = __webpack_public_path__ + "static/media/tank-shadow.d8682377.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tank-shadow.png
// module id = 1142
// module chunks = 0